export default {
  name: "Mithils By Keerthana",
  feedback: `A place where you can trustedly go and learn, and come back home with not only takeaways but a handful of hands-on experience and knowledge from basics.
My journey as a home baker all started with Ramya and she teaches so well that even someone who doesn't 
know baking can confidently bake a cake. I have almost 10 years of learning with her and attended many classes with her. 
Her teaching, methods, way of clearing doubts and after-support are simply amazing. Keep going Ramya Akka...`
};
